// import { Hero } from "../Hero/Hero";
import { SeiteHeader } from "../SeiteHeader/SeiteHeader";
import { HeadersOptionsType, StartPageType } from "@/types/ModuleOptionsType";
import { PostHeader } from "../PostHeader/PostHeader";
import { Hero } from "../Hero/Hero";

import { ParentsType } from "../../../wp/getParentPages";
// import { HeroSplitHeader } from "../Hero/HeroSplitHeader/HeroSplitHeader";
import { EventHeader } from "../EventHeader/EventHeader";
import { OptionsType } from "@/types/baseTypes";
import { Post, PostTypes } from "@/wp/types/client";
import { MagazineHeader } from "../MagazineHeader/MagazineHeader";
import {
  OptionsBackgroundLayoutType,
  OptionsHeaderType,
} from "@/types/OptionType";
import { TeamHeader } from "../TeamHeader/TeamHeader";
import { GlossarHeader } from "../GlossarHeader/GlossarHeader";
import { CatalogHeader } from "../CatalogHeader/CatalogHeader";
import VideoHeader from "../VideoHeader/VideoHeader";

interface HeaderProps<T extends PostTypes> {
  locale: string;
  post: Post<T>;
  headerOptions: HeadersOptionsType;
  startPageOptions: StartPageType;
  parents: ParentsType;
  options: OptionsHeaderType;
  socialMediaThemeOptions: OptionsType["acf"]["social_media"];
  backgroundImages: OptionsBackgroundLayoutType;
  searchPageSlug: string;
}

export const Header = <T extends PostTypes>({
  locale,
  post,
  headerOptions,
  startPageOptions,
  parents,
  options,
  socialMediaThemeOptions,
  backgroundImages,
  searchPageSlug,
}: HeaderProps<T>) => {
  // * header_startseite should be always first because there is a bug in the REST API.
  switch (post.type) {
    case "page": {
      if ("header_startseite" in post.acf) {
        return (
          <Hero
            header={post.acf.header_startseite}
            startPageOptions={startPageOptions}
            backgroundImages={backgroundImages}
            searchPageSlug={searchPageSlug}
          />
        );
      } else if ("header_seite" in post.acf) {
        return (
          <SeiteHeader
            post={post}
            headerOptions={headerOptions.header_pages}
            parents={parents}
            backgroundImages={backgroundImages}
          />
        );
      }
      break;
    }
    case "catalog": {
      return (
        <CatalogHeader
          post={post}
          headerOptions={headerOptions.header_catalog}
          parents={parents}
        />
      );
    }
    case "blog": {
      return (
        <PostHeader
          post={post}
          headerOptions={headerOptions.header_posts}
          parents={parents}
          fallbackImg={options.fallback_images.header_posts}
        />
      );
    }
    case "events": {
      return (
        <EventHeader
          locale={locale}
          post={post}
          headerOptions={headerOptions.header_events}
          parents={parents}
          fallbackImg={options.fallback_images.header_events}
        />
      );
    }
    case "magazine": {
      return (
        <MagazineHeader
          post={post}
          headerOptions={headerOptions.header_magazine}
          fallbackImg={options.fallback_images.header_magazine}
          parents={parents}
        />
      );
    }
    case "team": {
      return (
        <TeamHeader
          post={post}
          parents={parents}
          fallbackImg={options.fallback_images.header_team}
          headerOptions={headerOptions.header_team}
          socialMediaThemeOptions={socialMediaThemeOptions}
        />
      );
    }
    case "glossary":
      return (
        <GlossarHeader
          post={post}
          headerOptions={headerOptions.header_glossary}
          parents={parents}
          fallbackImg={options.fallback_images.header_glossar}
        />
      );
    case "videos": {
      return <VideoHeader post={post} />;
    }
  }
};
